import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const teamMembers = [
  {
    name: "Abhimanyu RB",
    role: "Founder",
    bio: "Passionate about empowering students to discover their true calling.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    name: "Aagneye Syam",
    role: "Founder",
    bio: "Dedicated to bridging the gap between generations through storytelling.",
    image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=400&fit=crop"
  },
  {
    name: "Abhijith B",
    role: "Co-founder",
    bio: "Focused on creating meaningful connections in the community.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  },
  {
    name: "Sarah Chen",
    role: "Community Manager",
    bio: "Expert in fostering engaging and supportive online communities.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
  },
  {
    name: "Raj Patel",
    role: "Content Creator",
    bio: "Crafting compelling stories that inspire and educate.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  },
  {
    name: "Maya Singh",
    role: "Social Media Manager",
    bio: "Building bridges across platforms to connect and engage.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
  }
];

export default function TeamPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-orange-50 text-gray-800 p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Button variant="ghost" asChild className="mb-6">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft size={20} />
              Back to Home
            </Link>
          </Button>

          <h1 className="text-4xl md:text-5xl font-bold text-yellow-800 mb-8 text-center">
            Meet Our Team
          </h1>

          <p className="text-xl text-center mb-12 max-w-3xl mx-auto">
            We're a dedicated group of individuals passionate about connecting generations
            and guiding students towards their dreams.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Card className="bg-white/80 backdrop-blur shadow-xl hover:shadow-2xl transition-shadow">
                  <CardContent className="p-6">
                    <div className="aspect-square mb-4 overflow-hidden rounded-full">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h2 className="text-2xl font-semibold text-yellow-700 mb-2">
                      {member.name}
                    </h2>
                    <h3 className="text-lg font-medium text-yellow-600 mb-3">
                      {member.role}
                    </h3>
                    <p className="text-gray-600">
                      {member.bio}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}